// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/xkCoach/wishListAnalyze/detail.less
// module id = 1674
// module chunks = 0